import { IProductionField } from './../../models/commission';

export const ProductionFields: IProductionField[] = [
  {
    label: 'Produção Inicial (R$):',
    controlName: 'InitialProduction',
    value: null,
    currencyMask: true
  },
  {
    label: 'Produção Final (R$):',
    controlName: 'FinalProduction',
    value: null,
    currencyMask: true
  },
  {
    label: 'Percentual (%)',
    controlName: 'Percentage',
    value: null,
    currencyMask: false
  }
];
